import React, { useState, useEffect } from 'react';
import Navbar from '../../layouts/full-layout/header/homeHeader';
import Footer from '../../layouts/full-layout/footer/Footer';
import PageContainer from '../../components/container/PageContainer';
import { Box, Button } from '@mui/material';
import LandingBanner from '../../assets/backgrounds/LandingPage.jpg';
import LandingMob from '../../assets/backgrounds/landing-mob.jpg';
import { useNavigate } from 'react-router';

const HomeAfter = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const navigate = useNavigate();

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleNavigate = () => {
    navigate('/activities');
  };

  return (
    <PageContainer title="Behtar 75" description="This is landing page" showHeader={false}>
      <Box
        sx={{
          height: '100vh', // Set the height to fill the viewport
          backgroundImage: isMobile ? `url(${LandingMob})` : `url(${LandingBanner})`,
          backgroundSize: 'cover', // Cover the entire box
          backgroundPosition: 'center', // Center the image
          position: 'relative', // Enable absolute positioning for child elements
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: isMobile ? 'absolute' : 'fixed', // Fixed for desktop, absolute for mobile
            top: isMobile ? '90%' : '60%', // Space from the bottom for mobile
            right: isMobile ? '50%' : '26%', // Center for mobile, right aligned for desktop
            transform: isMobile ? 'translateX(50%)' : 'none', // Center the button for mobile
            zIndex: 1, // Ensure the button is above the background
          }}
          onClick={handleNavigate}
        >
          Explore Now
        </Button>
      </Box>
    </PageContainer>
  );
};

export default HomeAfter;
